import { FaqBlock as FaqBlockTypes } from "@/payload-types";

import { RenderFaq } from "../components/Faq/RenderFaq";

export const FaqBlock: React.FC<FaqBlockTypes> = (props) => {
  return <RenderFaq {...props} />;
};
